module.exports = __webpack_public_path__ + "static/img/04.a3a29a3c.png";